module.exports = __webpack_public_path__ + "static/media/industries-batteries-s.b5d35ba7.webp";